// import {augmentApiUrl,devOfflineMode} from '../utils';
import axios from "axios";

export const addToCart = (
  {
    commit,
    /*state,*/
    getters,
  },
  sku
) => {
  return new Promise((resolve, reject) => {
    axios
      .get(getters.apiUrl + "/cartapi/add_to_cart/" + sku)
      .then(function(response) {
        // window.updateCartCount();
        // window.location = `/ex/cart`;
        // // window.showCartAdd();
        resolve(response.data.payload);
      })
      .catch(function(error) {
        reject(error.response);
      });
  });
};
